import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";

import BusinessExpenseRow from "@/components/v2/molecules/admin/tabs/BusinessExpensesTab/BusinessExpenseRow";
import { BusinessExpense } from "@/hooks/useBusinessExpenses";

interface BusinessExpenseTableProps {
  expenses: BusinessExpense[];
  onEdit: (expense: BusinessExpense) => void;
  onDelete: (expense: BusinessExpense) => void;
  onViewReceipt: (receiptUrl: string) => void;
  canEdit: boolean;
  canDelete: boolean;
  canDownload: boolean;
  selectedExpenses: string[];
  onSelectExpense: (expenseId: string, index: number, shiftKey: boolean) => void;
  onSelectAll: (checked: boolean) => void;
}

const BusinessExpenseTable = ({
  expenses,
  onEdit,
  onDelete,
  onViewReceipt,
  canEdit,
  canDelete,
  canDownload,
  selectedExpenses,
  onSelectExpense,
  onSelectAll,
}: BusinessExpenseTableProps) => {
  const showActions = canEdit || canDelete;

  const allSelected = expenses.length > 0 && selectedExpenses.length === expenses.length;
  const someSelected = selectedExpenses.length > 0 && selectedExpenses.length < expenses.length;

  const handleSelectAll = (checked: boolean) => {
    onSelectAll(checked);
  };

  const tableHeaders = [
    "",
    "Organización",
    "Propiedad",
    "Fecha de Pago",
    "Tipo de Egreso",
    "Subtipo de Egreso",
    "Tipo de Pago",
    "Descripción",
    "Pago Total",
    "Comprobante",
    ...(showActions ? ["Acciones"] : []),
  ];

  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            {tableHeaders.map((header, index) => (
              <TableHead key={index}>
                {index === 0 ? (
                  <Checkbox
                    checked={allSelected}
                    onCheckedChange={handleSelectAll}
                    aria-label="Seleccionar todos"
                    className={someSelected ? "data-[state=checked]:bg-primary/80" : ""}
                  />
                ) : (
                  header
                )}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody>
          {expenses.map((expense, index) => (
            <BusinessExpenseRow
              key={expense.id}
              expense={expense}
              index={index}
              onEdit={onEdit}
              onDelete={onDelete}
              onViewReceipt={onViewReceipt}
              canEdit={canEdit}
              canDelete={canDelete}
              canDownload={canDownload}
              isSelected={selectedExpenses.includes(expense.id)}
              onSelect={onSelectExpense}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default BusinessExpenseTable;
